import { render, staticRenderFns } from "./DeliveryAddressApprove.vue?vue&type=template&id=672c971a&scoped=true"
import script from "./DeliveryAddressApprove.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c971a",
  null
  
)

export default component.exports